import { DealsPage } from '@/features/shop/components/Deals/DealsPage'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { withHeaderLayout } from '@/features/shared/components/Headers/Layouts/HeaderLayout'
import { inferZipAndStoreForSlugifiedRoute } from '@/features/shared/serverUtils/inferZipAndStoreForSlugifiedRoute'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.RETAILER_DEALS,
  inferZipAndStoreForSlugifiedRoute,
)

// DealsPage is CMS driven
export default withHeaderLayout(DealsPage, {
  suppressFooter: true,
  showActivityPunchCardButton: true,
})
